import Cell from './cell.vue'
export default Cell



// WEBPACK FOOTER //
// ./src/components/cell/index.js